import React, { useContext, useState } from "react";

import { ChangePasswordForm } from "../../forms";
import { Collapsible } from "../../components";
import { SettingsContext } from "../../contexts";
import { ContactWizard } from "../Users";

import { isPrivateAddress } from "../../helpers/privateAddress.js";

import { AddressForm } from "./index.jsx";

const ProfileEditView = ({ user, authentication }) => {
  const { isRetailCircle } = useContext(SettingsContext);
  const [opened, setOpened] = useState({
    overview: true,
  });

  const formParams = {
    user,
    authentication,
  };

  const afterSubmit = () => {
    setOpened({
      overview: false,
    });
  };

  return (
    <div className="collapsibles mt-4 mb-4 profile-edit">
      <div className="overview">
        {/* The Overview / Business sections are the User creation page's own
            components, not Profile copies: ContactWizard (views/Users/Wizard)
            renders views/Users/OverviewForm + BusinessForm, with `isProfile`
            selecting the profile field order and hiding the create-only bits.
            Profile's former OverviewForm / InterestsForm duplicates are retired
            — no longer imported here nor exported from Profile/index.jsx. */}
        <ContactWizard user={user} afterSubmit={afterSubmit} isProfile />
      </div>
      {/* A 🏠-labelled default address is PRIVATE — never shown on /profile.
          The whole section goes (not just the values): the legacy
          PUT /users/{id}/address updates the default row in place, so a
          blank-but-visible form here could silently overwrite the hidden
          address on save. Manage it from the Users address book instead. */}
      {!isPrivateAddress(user?.address) && (
        <Collapsible trigger="Shipping Address" open={opened["address"]}>
          <AddressForm {...formParams} />
        </Collapsible>
      )}

      {!isRetailCircle && (
        <Collapsible trigger="Change password" open={opened["password"]}>
          <ChangePasswordForm user={user} />
        </Collapsible>
      )}
    </div>
  );
};

export default ProfileEditView;
